import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = {
    loading: false,
    data: [],
};

const mallSettingReducer = createReducer(initialState) ({
    [type.MALL_SETTING_LIST]: (state, action) => ({
        ...state,
        mall_setting_list: action.payload
    }),
    
    [type.UPDATE_MALL_SETTING_STATUS]: (state, action) => ({
        ...state,
        update_mall_setting_status: action.payload
    }),
});

export default mallSettingReducer;